import type { FC } from 'react';
import { useRouter } from 'next/router';
import type { UserBase, CongressBase } from '@domain/index';
import { printerTest } from '@lib/receipts';

import { EuiFlexGroup, EuiFlexItem, EuiCard, EuiIcon } from '@elastic/eui';
import {
  MdOutlineAssignmentInd,
  MdOutlineReceiptLong,
  MdOutlinePrint,
  MdOutlineSettings,
} from 'react-icons/md';

interface MainMenuProps {
  congress: CongressBase;
  user: UserBase;
}

const MainMenu: FC<MainMenuProps> = ({ congress, user }) => {
  const router = useRouter();

  return (
    <EuiFlexGroup gutterSize="l" direction="column">
      <EuiFlexItem>
        <EuiCard
          layout="horizontal"
          title="Register"
          description="Register delegates or attendees"
          icon={<EuiIcon type={MdOutlineAssignmentInd} size="xxl" />}
          isDisabled={!congress.active}
          href="/register"
          onClick={(e: React.MouseEvent) => {
            e.preventDefault();
            router.push('/register');
          }}
        />
      </EuiFlexItem>
      <EuiFlexItem>
        <EuiCard
          layout="horizontal"
          title={
            congress.votingCodeAtRegistration
              ? 'Reprint voting code'
              : 'Print voting code'
          }
          description={
            congress.votingCodeAtRegistration
              ? "Reprint delegate's voting code"
              : "Print delegate's voting code"
          }
          icon={<EuiIcon type={MdOutlineReceiptLong} size="xxl" />}
          isDisabled={!congress.active}
          href="/print-codes"
          onClick={(e: React.MouseEvent) => {
            e.preventDefault();
            router.push('/print-codes');
          }}
        />
      </EuiFlexItem>
      <EuiFlexItem>
        <EuiCard
          layout="horizontal"
          title="Printer test"
          description="Test the receipt printer"
          icon={<EuiIcon type={MdOutlinePrint} size="xxl" />}
          onClick={() => {
            printerTest(congress);
          }}
        />
      </EuiFlexItem>
      {user.admin === true && (
        <EuiFlexItem>
          <EuiCard
            layout="horizontal"
            title="Manage"
            description="Manage congress settings and delegates"
            icon={<EuiIcon type={MdOutlineSettings} size="xxl" />}
            href="/manage"
            onClick={(e: React.MouseEvent) => {
              e.preventDefault();
              router.push('/manage');
            }}
          />
        </EuiFlexItem>
      )}
    </EuiFlexGroup>
  );
};

export default MainMenu;
